module.exports = __webpack_public_path__ + "static/media/signage-industrial-img20.47054603.jpg";